import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_aysyz36773: FaireBrandEntity = {
  token: "b_aysyz36773",
  type: "brand",
  name: "The Heady Chic",
  avatarUrl:
    "https://cdn.faire.com/fastly/8a3bc108b951ef5036226ff19d2cba8bf841863c7f515bb4240f94157ca4bd26.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/897d8b7fa7a1aba8a23e11fd8816b325688aab6c159e17eca793ee45953f387a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8a3bc108b951ef5036226ff19d2cba8bf841863c7f515bb4240f94157ca4bd26.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/897d8b7fa7a1aba8a23e11fd8816b325688aab6c159e17eca793ee45953f387a.png",
  location: "Hattiesburg, MS, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "Welcome to our store! We are so grateful for your business and know that you will love our products as much as we do!! We are sisters, best friends, moms, and business partners. Patricia resides in Hattiesburg, MS, and Kelly is in Wilmington, Coastal NC. We love that we get to work together and pour our creative energy into our beautiful products.\n\nThe Heady Chic brings you stylish, handcrafted headbands, bows, and scrunchies for all ages. Designed for comfort and flair, our accessories are perfect for every occasion! \n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:21.228Z",
    importedBy: "entity-db-cli",
  },
};
